import { useEffect, useState } from 'react';
import { getUserInfo } from '../api/getUserInfo';
import Raven from 'raven-js';
export const useGates = () => {
  const [userGates, setGates] = useState([]);
  useEffect(() => {
    getUserInfo().then(({
      gates
    }) => {
      setGates(gates);
    }).catch(error => {
      Raven.captureException(error);
    });
  }, []);
  return userGates;
};